var map = {
	"./oland_ankr.js": 31711,
	"./oland_arpa.js": 41766,
	"./oland_bel.js": 35830,
	"./oland_food.js": 81899,
	"./oland_metal.js": 90763,
	"./oland_water.js": 45052,
	"./oland_wood.js": 51329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10992;